import { searchAndSaveIntersectedPolygons } from '../../Module/graphQL/PathFinder/pathFinderGQL'

export const searchAndSaveIntersectedPolygonsHandler = async ({
  cityId,
  cityName,
  collectionName,
  d2dDistributionZones,
  offset,
  setSavedPercentage,
}) => {
  const response = await searchAndSaveIntersectedPolygons({
    cityId,
    cityName,
    collectionName,
    d2dDistributionZones,
    offset,
  })

  const responseParsed = await response.json()

  const {
    data: {
      searchAndSaveIntersectedPolygons: { hasNextPage, endCursor, totalCount },
    },
  } = responseParsed

  const offsetParsed = offset
    ? Number(Buffer.from(offset, 'base64').toString('ascii'))
    : 0

  const savedPercentage = ((offsetParsed * 100) / totalCount).toFixed()

  if (savedPercentage != 0) {
    setSavedPercentage(savedPercentage)
  }

  if (hasNextPage) {
    return await searchAndSaveIntersectedPolygonsHandler({
      cityId,
      cityName,
      collectionName,
      d2dDistributionZones,
      offset: endCursor,
      setSavedPercentage,
    })
  } else {
    setSavedPercentage(100)
    return responseParsed
  }
}
